<template>
    <div class="layer themeColor">
        <div class="card">
            <h2> ألوان الثيمة </h2>
            <br>
            <section>
                <div @click="closeTheWindowTheme(); prpl()" style="background: #5e60ce;" class="color"></div>
                <div @click="closeTheWindowTheme(); red()" style="background: #c1121f;" class="color"></div>
                <div @click="closeTheWindowTheme(); orange()" style="background: #c77e6b;" class="color"></div>
                <div @click="closeTheWindowTheme(); blue()" style="background: #669bbc;" class="color"></div>
                <div @click="closeTheWindowTheme(); yellow()" style="background: #b69121;" class="color"></div>
                <!-- <div onclick="$(this).parent().parent().parent().fadeOut(300);" style="background: #464545;" class="color"></div> -->
                <div @click="closeTheWindowTheme(); darkPrpl()" style="background: #7b3f56;" class="color"></div>
            </section>
            <br>
            <section>
                <button class="resetTheme" @click="closeTheWindowTheme(); reset()">
                    إعادة الضبط
                </button>
                <button @click="closeTheWindowTheme"> تم </button>
            </section>
            <!-- content Here -->
        </div>
    </div>
</template>

<script>
export default {
    
    //props: ["propNightMode"],
    data() {
        return {
            theme: {
                prpl: "#5e60ce",
                red: "#c1121f",
                orange: "#c77e6b",
                blue: "#669bbc",
                // gray: "#464545",
                yellow: "#b69121",
                darkPrpl: "#7b3f56",
                night: true
                // night: this.propNightMode,
            },
            
        }
    },
    watch: {
        night() {
            console.log("night props changed in watcher");
        }
    },
    methods: {
        closeTheWindowTheme() {
            this.$emit("closeTheme", false);
        },
        
        /**
         * emiting the localStorage data of the colors...idk why.
         * they are sorted already in the lclstrg but
         * idk why emit them to parent...
         */
        prpl() {
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.prpl + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.prpl}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.prpl}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.prpl);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                // this.$emit("themeMode", [
                //     window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
                //     window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
                //     window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
                // ]);
            }
            else {
                document.documentElement.style.setProperty("--mainColor", this.theme.prpl + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.prpl}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.prpl}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.prpl);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                // this.$emit("themeMode", [
                //     window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
                //     window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
                //     window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
                // ]);
            }
        },
        red() {   
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.red + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.red}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.red}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.red);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                // this.$emit("themeMode", [
                //     window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
                //     window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
                //     window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
                // ]);
            } else {
                document.documentElement.style.setProperty("--mainColor", this.theme.red + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.red}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.red}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.red);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            //     this.$emit("themeMode", [
            //         window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
            //         window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
            //         window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
            // ]);
            }
        },
        orange() {   
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.orange + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.orange}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.orange}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.orange);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                // this.$emit("themeMode", [
                //     window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
                //     window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
                //     window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
                // ]);
            } else {
                document.documentElement.style.setProperty("--mainColor", this.theme.orange + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.orange}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.orange}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.orange);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                // this.$emit("themeMode", [
                //     window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor")),
                //     window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity")),
                //     window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"))
                    
                // ]);
            }
        },
        blue() {
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.blue + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.blue}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.blue}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.blue);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                //this.$emit("themeMode", []);
            } else {
                document.documentElement.style.setProperty("--mainColor", this.theme.blue + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.blue}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.blue}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.blue);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
                //this.$emit("themeMode", []);
            }
        },
        yellow() {     
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.yellow + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.yellow}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.yellow}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.yellow);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            } else {
                document.documentElement.style.setProperty("--mainColor", this.theme.yellow + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.yellow}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.yellow}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.yellow);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            }
        },
        darkPrpl() {
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", this.theme.darkPrpl + "77");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.darkPrpl}55`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.darkPrpl}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.darkPrpl);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            } else {
                document.documentElement.style.setProperty("--mainColor", this.theme.darkPrpl + "ff");
                document.documentElement.style.setProperty("--mainColorOpacity", `${this.theme.darkPrpl}66`);
                document.documentElement.style.setProperty("--mainColorText", `${this.theme.darkPrpl}`);
                document.querySelector("meta[name='theme-color']").setAttribute("content", this.theme.darkPrpl);
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            }
        },
        reset() {
            if (this.propNightMode) {
                document.documentElement.style.setProperty("--mainColor", "#00DE9A77");
                document.documentElement.style.setProperty("--mainColorOpacity", "#00DE9B55");
                document.documentElement.style.setProperty("--mainColorText", "#00ac68");
                document.querySelector("meta[name='theme-color']").setAttribute("content", "#00DE9A");
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            }
            else {
                document.documentElement.style.setProperty("--mainColor", "#00DE9Aff");
                document.documentElement.style.setProperty("--mainColorOpacity", "#00DE9B66");
                document.documentElement.style.setProperty("--mainColorText", "#00ac68");
                document.querySelector("meta[name='theme-color']").setAttribute("content", "#00DE9A");
                window.localStorage.setItem("themeColor", document.documentElement.style.getPropertyValue("--mainColor"));
                window.localStorage.setItem("themeColorOpacity", document.documentElement.style.getPropertyValue("--mainColorOpacity"));
                window.localStorage.setItem("themeColorText", document.documentElement.style.getPropertyValue("--mainColorText"));
            }
        }
    }
} 
</script>